<template>
  <div id="Requisition-create" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue darken-2"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form ref="RequisitionForm" v-model="valid">
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock :headerText="headerText"></HeaderDividerBlock>
            <v-row>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-autocomplete
                    v-model="formData.branch_id"
                    :items="branches"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    clearable
                    :rules="[rules.required]"
                    placeholder="Select Branch"
                  ></v-autocomplete>
                </v-col>
              </v-col>

              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Expected Delivery Date</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-menu
                    v-model="datePicker.menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="formData.expected_delivery_date"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.expected_delivery_date"
                      no-title
                      @input="datePicker.menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-col>
            </v-row>

            <v-col cols="12">
              <ItemsTable
                :items="formData.items"
                :productsArray="productsArray"
                @add-item="addItem"
                @remove-item="removeItem"
              />
            </v-col>

            <v-col cols="6" md="4" sm="6" v-if="mode === 'edit'">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Status</p>
              </v-col>
              <v-col class="pa-0 ma-0">
                <v-select
                  v-model="formData.status"
                  :items="statusOptions"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                  :rules="[rules.required]"
                  placeholder="Select Status"
                ></v-select>
              </v-col>
            </v-col>

            <v-col cols="12">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Comments</p>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="formData.comment"
                  outlined
                  dense
                  auto-grow
                  placeholder="Comments"
                ></v-textarea>
              </v-col>
            </v-col>

            <v-col cols="12" md="12" sm="12">
              <v-card-actions class="mt-10">
                <v-row>
                  <v-col cols="12" md="10" xs="6"></v-col>
                  <v-col cols="12" md="2" xs="6">
                    <v-btn
                      v-if="
                        (mode === 'edit' &&
                          hasPermission('requisition.edit')) ||
                          (mode != 'edit' &&
                            hasPermission('requisition.create'))
                      "
                      large
                      color="#00B3FF"
                      dark
                      depressed
                      block
                      @click="submitForm"
                    >
                      {{
                        mode === "edit"
                          ? "Update Requisition"
                          : "Create Requisition"
                      }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import ItemsTable from "@/components/Requisition/ItemsTable.vue";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import Alert from "@/components/shared/Alert";
import { RequisitionService } from "@/services/requisition-service.js";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "RequisitionCreateForm",
  components: { ItemsTable, HeaderDividerBlock, Alert },
  props: {
    formData: { type: Object, required: true },
    mode: { type: String, required: true },
    id: { type: String, required: false },
    proploading: { type: Boolean, required: true },
    productsArray: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: this.proploading,
      valid: false,
      datePicker: {
        menu: false,
        min: new Date().toISOString().substr(0, 10),
      },
      branches: [],
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      errors: null,
      statusOptions: [
        { label: "Pending", value: "pending" },
        { label: "Approved", value: "approved" },
        { label: "Rejected", value: "rejected" },
      ],
    };
  },
  methods: {
    addItem() {
      this.formData.items.push({
        product_id: "",
        description: "",
        quantity: 0,
      });
    },
    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    resetForm() {
      this.formData = {
        branch_id: "",
        items: [],
        comment: "",
        expected_delivery_date: "",
      };
      // this.$refs.poForm.reset();
    },

    async submitForm() {
      if (!this.$refs.RequisitionForm.validate()) return;
      this.loading = true;
      try {
        if (this.mode === "create") {
          await RequisitionService.createRequisition(this.formData);
        } else {
          await RequisitionService.updateRequisition(this.id, this.formData);
        }
        this.$router.push({ name: "RequisitionsList" });
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },

    async fetchBranches() {
      this.loading = true;

      try {
        const [branchesResponse] = await Promise.all([
          RequisitionService.getBranches(),
        ]);

        this.branches = branchesResponse.data;
      } catch (error) {
        console.error("Error fetching Branches:", error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },

    onDismissed() {
      this.errors = null;
    },
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    headerText() {
      return this.mode === "edit" ? "Update Requisition" : "Create Requisition";
    },
  },

  async created() {
    this.fetchBranches();
  },

  watch: {
    proploading(newVal) {
      this.loading = newVal;
    },
  },
};
</script>
